import React from "react";
import "./css/skeleton-loader.css";

const SkeletonLoader = ({ title }) => {
  return (
    <div className="skeleton-loader-container">
      <div className="skeleton-loader">
        <h4 style={{ fontFamily: "Roboto", fontSize: "2rem" }}> {title}</h4>
      </div>
    </div>
  );
};

export default SkeletonLoader;
